var _rect, _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgResetPassword = function SvgResetPassword(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#F3F5F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.875 24V19.1953C16.875 15.2578 20.0391 12.0141 23.9766 12C27.9141 11.9859 31.125 15.1875 31.125 19.125V19.875C31.1254 20.0228 31.0965 20.1693 31.0401 20.306C30.9837 20.4426 30.9009 20.5668 30.7963 20.6713C30.6918 20.7759 30.5676 20.8587 30.431 20.9151C30.2943 20.9715 30.1478 21.0004 30 21H28.5C28.3522 21.0004 28.2057 20.9715 28.069 20.9151C27.9324 20.8587 27.8082 20.7759 27.7037 20.6713C27.5991 20.5668 27.5163 20.4426 27.4599 20.306C27.4035 20.1693 27.3746 20.0228 27.375 19.875V19.125C27.3743 18.6792 27.2855 18.238 27.1136 17.8266C26.9417 17.4153 26.6901 17.0421 26.3734 16.7284C26.0566 16.4147 25.681 16.1667 25.268 15.9988C24.8551 15.8309 24.413 15.7464 23.9672 15.75C22.1109 15.7688 20.625 17.3109 20.625 19.1672V24H16.875Z",
    fill: "#18379A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.25 24H15.75C15.1533 24 14.581 24.2371 14.159 24.659C13.7371 25.081 13.5 25.6533 13.5 26.25V33.75C13.5 34.3467 13.7371 34.919 14.159 35.341C14.581 35.7629 15.1533 36 15.75 36H32.25C32.8467 36 33.419 35.7629 33.841 35.341C34.2629 34.919 34.5 34.3467 34.5 33.75V26.25C34.5 25.6533 34.2629 25.081 33.841 24.659C33.419 24.2371 32.8467 24 32.25 24ZM25.875 31.125C25.875 31.6223 25.6775 32.0992 25.3258 32.4508C24.9742 32.8025 24.4973 33 24 33C23.5027 33 23.0258 32.8025 22.6742 32.4508C22.3225 32.0992 22.125 31.6223 22.125 31.125V28.875C22.125 28.3777 22.3225 27.9008 22.6742 27.5492C23.0258 27.1975 23.5027 27 24 27C24.4973 27 24.9742 27.1975 25.3258 27.5492C25.6775 27.9008 25.875 28.3777 25.875 28.875V31.125Z",
    fill: "#18379A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 24,
    fill: "white",
    transform: "translate(13.5 12)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResetPassword, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reset-password.90b7cd68.svg";
export { ForwardRef as ReactComponent };